import { Collapse, Grid } from "@mui/material";
import FormSection from "../../Forms/FormSection/form-section";
import PermissionCard from "./permission-card";
import PermissionSummary, { PermissionSummaryProps } from "./permission-summary";
import { useToggle } from "../../../Utils/Hooks/useToggle";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import React from "react";
import { PermissionType } from "../../../Core/Api/Types/permission-type";
import { useTranslation } from "react-i18next";

interface PermissionsFormSectionProps {
  selectedPermissions: PermissionType[];
  handlePermissionClick(permission: PermissionType): void;
  variant: PermissionSummaryProps["variant"];
  allowedPermissions?: PermissionType[];
  disabledPermissions?: PermissionType[];
}

const PermissionsFormSection = (props: PermissionsFormSectionProps) => {
  const { t } = useTranslation();
  const { selectedPermissions, handlePermissionClick, variant, allowedPermissions, disabledPermissions } = props;

  const { active: permissionsExpanded, toggle: togglePermissionsExpanded } = useToggle(true);
  const allPermissions = React.useMemo(() => {
    return allowedPermissions
      ? allowedPermissions.sort()
      : (Object.keys(PermissionType) as Array<PermissionType>).sort();
  }, []);

  return (
    <FormSection
      title={t("common:permissions")}
      expanded={permissionsExpanded}
      onExpand={togglePermissionsExpanded}
      icon={<LockOpenOutlinedIcon />}
      status="custom"
      customStatus={
        <Collapse in={!permissionsExpanded}>
          <PermissionSummary
            selectedPermissions={selectedPermissions}
            allowedPermissions={allowedPermissions}
            variant={variant}
          />
        </Collapse>
      }
    >
      <Grid container spacing={1}>
        {allPermissions.map((permission, index) => (
          <Grid key={index} item xs={6} sx={{ display: "flex" }}>
            <PermissionCard
              permission={permission}
              selected={selectedPermissions.includes(permission)}
              onClick={() => handlePermissionClick(permission)}
              sx={{ flexGrow: 1 }}
              disabled={disabledPermissions?.includes(permission)}
            />
          </Grid>
        ))}
      </Grid>
    </FormSection>
  );
};

export default PermissionsFormSection;
